import { CheckBox, Spacer } from "@components/atoms";
import React, { memo, useEffect, useState } from "react";
import styled from "styled-components/native";
import { Platform, Pressable, View } from "react-native";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon from "@components/icons/VDBIcon";
import { IconsVariant } from "@components/icons/VDBIcon";
import { useTheme } from "styled-components/native";
import { RequestDetailTabletProps } from "./types";
import {
  getProductListViewData,
  preventLeftClickWeb,
} from "@scenes/searchResults/Utils";
import { navigate } from "@navigations/utils/RootNavigation";
import {
  useDisplayImage,
  useSortedTabletListData,
} from "../../../hooks/useSortCustomData";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { VDBIcons } from "@utils/VDBIcons";
import * as styledDiv from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { getProductThemeFromType } from "@components/common/Header/utils";
import TabletListItem from "./TabletListItem";
import { getProductTypeFromRequest } from "../utils/RequestsScreen";
import { setProductType } from "@redux/slices/appStateSlice";
import { setSectionName } from "@redux/slices/searchFilters";
import Routes from "@navigations/Routes";
import { showToast, ToastTypes } from "@components/molecules/VDBToast/util";
import { useTranslation } from "react-i18next";
import {
  getRequestType,
  RequestTypes,
  showRequestItemFromSupplier,
} from "../utils/utils";
import { ViewType } from "@utils/constants";
import { MAX_WEB_DRAWER_WIDTH } from "@navigations/utils/constants";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import { StoneType } from "@scenes/bulk-request/Utils";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { formatNumberWithPrecision } from "@utils/product/productFormatters";
import {
  createItemDetailLink,
  getSectionName,
} from "@utils/product/searchResultsNavigation";
import { isMeleeItem } from "@utils/product/productValidators";

const RequestDetailTabletListItem = ({
  mItem,
  index,
  checkBoxSelection,
  ismItemChecked,
  productType,
  favoriteClickedFunction,
  removeFavorite,
  customizeColumnParams,
  userCurrency,
  productPrefix,
  fromRequestDetail,
  stockItemRequest,
  showListPrice = true,
  isTotalOfferDiscountApplied,
  request_type,
  hasAnyOfferDetails,
  viewType = "",
  stockItemRequestParent,
  sectionName = SearchFilterTypeEnum.SINGLE_STONES,
}: RequestDetailTabletProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const userInfo = useUserInfo();
  const userPriceMode = userInfo.user.price_mode;
  const dispatch = useDispatch();
  const isCustomApp = useSelector((state) => state?.appState?.isCustomApp);

  const [isItemChecked, setIsItemChecked] = useState(
    mItem?.is_selected || ismItemChecked || false
  );
  const [isFavorite, setIsFavorite] = useState(false);
  const { deviceWidth: screenWidth } = useIsFoldable();

  const productListViewData = getProductListViewData(productType);
  const productTheme = getProductThemeFromType(productType);
  const isTotalOfferPriceApplied =
    stockItemRequest?.quote_details?.total_offer_price_applied;

  const defaultListDataOptions = useSortedTabletListData(
    productType,
    userPriceMode,
    sectionName,
    false,
    fromRequestDetail,
    sectionName === SearchFilterTypeEnum.PAIRS
      ? StoneType.PAIR
      : sectionName === SearchFilterTypeEnum.PARCEL
      ? StoneType.PARCELS
      : StoneType.SINGLE_STONES
  );

  const listDataOptions =
    customizeColumnParams && customizeColumnParams.length > 0
      ? customizeColumnParams
      : productListViewData && productListViewData.length > 0
      ? productListViewData
      : defaultListDataOptions;

  let hideTotalPrice =
    getRequestType(viewType) !== RequestTypes.Quote
      ? true
      : request_type === ViewType.BUYER ||
        showListPrice ||
        isTotalOfferDiscountApplied;

  const defaultKeys = [
    "offer_price_per_carat",
    "offer_total_sales_price",
    "offer_discount_percent",
  ];

  const extraKeys = [
    "price_per_carat",
    "total_sales_price",
    "TotalPrice",
    "discount_percent",
  ];

  let keysToRemove: string[] = [];

  if (request_type === "buyer_view" && hasAnyOfferDetails) {
    keysToRemove = [];
  } else if (request_type === "seller_view" && hasAnyOfferDetails) {
    if (getRequestType(viewType) === RequestTypes.Quote) {
      keysToRemove = [...extraKeys];
    }
  } else if (
    request_type === "seller_view" &&
    (!hideTotalPrice || isTotalOfferPriceApplied)
  ) {
    keysToRemove = [...defaultKeys, ...extraKeys];
  } else {
    keysToRemove = [...defaultKeys];
  }

  const hasValidChild = stockItemRequestParent?.children?.some((child) =>
    showRequestItemFromSupplier(child)
  );

  if (
    (request_type === "seller_view" && !hasValidChild) ||
    request_type === "buyer_view"
  ) {
    keysToRemove = [...keysToRemove, "request_item_from_supplier"];
  }

  const listDataOptionsWithListPrice = listDataOptions
    .filter((item: any) => !keysToRemove.includes(item.response_key))
    .map((item: any) => ({
      ...item,
    }));

  const checkOfferApplied = () => {
    const itemTotal = Object.values(stockItemRequestParent?.children).reduce(
      (sum, item: any) =>
        sum +
        Number(
          item?.updated_total_sales_price || item?.offer_total_sales_price
        ),
      0
    );
    return (
      formatNumberWithPrecision(
        stockItemRequestParent?.offer_total_sales_price,
        {
          precision: userInfo?.roundUpPrices() && !isMeleeItem(mItem) ? 0 : 2,
        }
      )?.replaceAll(",", "") !==
      formatNumberWithPrecision(itemTotal, {
        precision: userInfo?.roundUpPrices() && !isMeleeItem(mItem) ? 0 : 2,
      })?.replaceAll(",", "")
    );
  };

  const displayImage = useDisplayImage(productType) ?? false;
  const Wrapper =
    (stockItemRequestParent?.additional_attributes?.total_offer_price_applied ||
      getRequestType(viewType) === RequestTypes.Buy ||
      getRequestType(viewType) === RequestTypes.Quote) &&
    (isTotalOfferPriceApplied || checkOfferApplied()) &&
    isTotalOfferDiscountApplied === false &&
    !hasAnyOfferDetails
      ? Pressable
      : View;

  const checkStateChanged = () => {
    if (stockItemRequest?.status !== "pending") {
      return;
    }
    if (
      stockItemRequestParent?.additional_attributes
        ?.total_offer_price_applied ||
      getRequestType(viewType) === RequestTypes.Buy ||
      getRequestType(viewType) === RequestTypes.Quote
    ) {
      if (
        (isTotalOfferPriceApplied || checkOfferApplied()) &&
        isTotalOfferDiscountApplied === false &&
        !hasAnyOfferDetails
      ) {
        showToast(
          "",
          getRequestType(viewType) === RequestTypes.Quote
            ? t("requestHistoryDetail.quote.quoteWarning.text")
            : t("requestHistoryDetail.buy.buyWarning.text"),
          ToastTypes.ERROR,
          true,
          true,
          80
        );
        return;
      }
    }

    const newCheckedState = !isItemChecked;
    setIsItemChecked(newCheckedState);
    checkBoxSelection(newCheckedState, mItem, productType);
  };

  useEffect(() => {
    setIsItemChecked(mItem?.is_selected || ismItemChecked || false);
  }, [ismItemChecked, mItem?.is_selected]);

  useEffect(() => {
    if (mItem?.is_favorite !== undefined) {
      setIsFavorite(mItem?.is_favorite);
    }
  }, [mItem?.is_favorite]);

  return (
    <StyledDiv
      theme={theme}
      isChecked={isItemChecked}
      productType={productTheme}
      isOdd={index ? index % 2 !== 0 : false}
      {...(theme.isLargeScreen
        ? { width: screenWidth + MAX_WEB_DRAWER_WIDTH - 1030 }
        : {})}
    >
      <Pressable
        onPress={() => {
          const productSearchType = getProductTypeFromRequest(
            productType?.productType
          );
          dispatch(setProductType(productSearchType));
          dispatch(setSectionName(getSectionName(productSearchType)));

          if (
            getRequestType(viewType) === RequestTypes.Quote ||
            getRequestType(viewType) === RequestTypes.Buy ||
            getRequestType(viewType) === RequestTypes.Memo ||
            getRequestType(viewType) === RequestTypes.Hold
          ) {
            if (Platform.OS === "web") {
              const queryParams = new URLSearchParams({
                id: mItem?.stock_id || "",
                requestName: stockItemRequest?.request_name,
                productType: JSON.stringify(productType),
                t: Date.now().toString(), // Timestamp for uniqueness
              }).toString();

              window.history.pushState(
                {
                  screen: Routes.RequestDetailScreen,
                  params: {
                    initial: false,
                    id: mItem?.stock_id,
                    requestName: getRequestType(viewType),
                    isReceivedRequest: false,
                    productType: productType,
                    price_mode: userInfo.getPriceMode(),
                    skip_unread: theme.isMobile ? false : true,
                  },
                },
                "",
                `/request-detail?${queryParams}`
              );
            }

            if (Platform.OS === "web") {
              navigate(Routes.RequestHistoryNavigator, {
                screen: Routes.RequestDetailScreen,
                params: {
                  initial: false,
                  id: mItem?.stock_id,
                  requestName: getRequestType(viewType),
                  isReceivedRequest: false,
                  productType: productType,
                  price_mode: userInfo.getPriceMode(),
                  skip_unread: theme.isMobile ? false : true,
                  stockItemRequestParent,
                },
              });
            } else {
              navigate(Routes.RequestHistoryChildDetail, {
                initial: false,
                id: mItem?.stock_id,
                requestName: stockItemRequest?.request_name,
                isReceivedRequest: false,
                productType: productType,
                price_mode: userInfo.getPriceMode(),
                skip_unread: theme.isMobile ? false : true,
                stockItemRequestParent,
              });
            }
          } else {
            navigate(Routes.GlobalNavigator, {
              screen: Routes.PDPScreen,
              params: {
                productID: mItem?.id,
                productType: mItem?.type,
                fromRequestDetailsScreen: true,
              },
            });
          }
        }}
      >
        <FirstContentMapContainer>
          <TableCell
            displayImage={displayImage}
            fromBulkList={fromRequestDetail}
            sectionName={sectionName}
          >
            {!userInfo.isIFrame() && (
              <>
                <Wrapper
                  onPress={
                    (isTotalOfferPriceApplied || checkOfferApplied()) &&
                    isTotalOfferDiscountApplied === false &&
                    !hasAnyOfferDetails
                      ? checkStateChanged
                      : undefined
                  }
                >
                  <CheckBox
                    fillColor={theme["knob-bor"]}
                    checkBoxSize={!theme.isLargeScreen ? 24 : 16}
                    checkedFunction={checkStateChanged}
                    isChecked={isItemChecked}
                    checkboxRadius={!theme.isLargeScreen ? 6 : 4}
                    disabled={
                      (isTotalOfferPriceApplied || checkOfferApplied()) &&
                      isTotalOfferDiscountApplied === false &&
                      !hasAnyOfferDetails
                        ? true
                        : stockItemRequest?.status !== "pending"
                    }
                  />
                </Wrapper>
                {!removeFavorite && (
                  <>
                    <Spacer
                      size={!theme.isDesktop ? SpaceType.Big : SpaceType.Basic}
                    />
                    <Pressable
                      style={{ justifyContent: "center" }}
                      onPress={() => favoriteClickedFunction(isFavorite, mItem)}
                    >
                      <VDBIcon
                        color={theme[isFavorite ? "error-01" : "extra-01"]}
                        size={!theme.isLargeScreen ? 24 : 16}
                        variant={IconsVariant.VDBCustom}
                        name={isFavorite ? VDBIcons.FAV : VDBIcons.FAV_EMPTY}
                      />
                    </Pressable>
                  </>
                )}
              </>
            )}
          </TableCell>
          <OverlayWeb
            {...(Platform.OS === "web" && {
              href: createItemDetailLink({
                productID: mItem?.stock_id,
                productType,
                priceMode: userInfo.getPriceMode(),
                productPrefix,
              }),
            })}
            {...(Platform.OS === "web" && {
              onClick: preventLeftClickWeb,
            })}
          >
            {listDataOptionsWithListPrice?.map((item, _index) => (
              <TabletListItem
                item={item}
                isCustomApp={isCustomApp}
                mItem={mItem}
                userCurrency={userCurrency}
                userInfo={userInfo}
                _index={_index}
                displayImage={displayImage}
                fromBulkList={false}
                fromRequestDetail={true}
                stockItemRequest={stockItemRequest}
                sectionName={sectionName}
                requestItemFromSupplier={stockItemRequestParent?.children?.some(
                  (child) => showRequestItemFromSupplier(child)
                )}
              />
            ))}
          </OverlayWeb>
        </FirstContentMapContainer>
      </Pressable>
    </StyledDiv>
  );
};

const FirstContentMapContainer = styled.View`
  flex-direction: row;
`;
const TableCell = styled.View<{
  displayImage?: boolean;
  fromBulkList?: boolean;
  sectionName?: SearchFilterTypeEnum;
}>`
  padding-top: ${({ displayImage, theme, fromBulkList, sectionName }) =>
    sectionName === SearchFilterTypeEnum.PAIRS
      ? "18px"
      : displayImage || !theme.isTablet
      ? `${SpaceType.Basic}px`
      : theme.isTablet && !fromBulkList
      ? `${SpaceType.Double}px`
      : `${SpaceType.Basic}px`};
  padding-bottom: ${({ displayImage, theme, fromBulkList, sectionName }) =>
    sectionName === SearchFilterTypeEnum.PAIRS
      ? "18px"
      : displayImage || !theme.isTablet
      ? `${SpaceType.Basic}px`
      : theme.isTablet && !fromBulkList
      ? `${SpaceType.Double}px`
      : `${SpaceType.Basic}px`};
  padding-left: ${SpaceType.Double}px;
  padding-right: ${SpaceType.Double}px;
  flex-direction: row;
  align-items: space-between;
`;

const StyledDiv =
  Platform.OS === "web"
    ? styledDiv.default.div<{
        width: number;
        isChecked?: boolean;
        isOdd?: boolean;
        productType: string;
      }>`
      min-width: ${({ width }) => width}px;
      flex-direction: column;
      background-color: ${({ theme, isChecked, isOdd, productType }) => {
        if (isChecked) {
          return theme[`${productType}-03`];
        }
        return isOdd ? theme["core-02"] : theme["core-01"];
      }};
      &:hover {
        background-color: ${({ theme, productType }) =>
          theme[`${productType}-03`]};
      }
    `
    : styled.View<{
        width: number;
        isChecked?: boolean;
        isOdd?: boolean;
        productType: string;
      }>`
        min-width: ${({ width }) => width}px;
        flex-direction: column;
        background-color: ${({ theme, isChecked, isOdd, productType }) => {
          if (isChecked) {
            return theme[`${productType}-03`];
          }
          return isOdd ? theme["core-02"] : theme["core-01"];
        }};
      `;

const OverlayWeb =
  Platform.OS === "web"
    ? styled.View.attrs(() => ({ as: "a" as any }))`
        text-decoration: none;
        display: flex;
        flex: 1;
      `
    : ({ children }: { children: React.ReactNode }) => <>{children}</>;

export default memo(RequestDetailTabletListItem, (prev, next) => {
  return (
    prev.mItem === next.mItem &&
    prev.checkBoxSelection === next.checkBoxSelection &&
    prev.ismItemChecked === next.ismItemChecked &&
    prev.productType === next.productType &&
    prev.favoriteClickedFunction === next.favoriteClickedFunction &&
    prev.priceMode === next.priceMode &&
    prev.customizeColumnParams === next.customizeColumnParams &&
    prev.productPrefix === next.productPrefix &&
    prev.userCurrency === next.userCurrency &&
    prev.showListPrice === next.showListPrice &&
    prev.hasAnyOfferDetails === next.hasAnyOfferDetails &&
    prev.isTotalOfferDiscountApplied === next.isTotalOfferDiscountApplied
  );
});
